// 変更前の値を表示するためのAttributeIDのサフィックス
export const PREVIOUS_SUFFIX = "PreviousValue";
